import at from 'lodash/at';
import omit from 'lodash/omit';
import createItem from './helpers/create-item';
import readList from './helpers/read-list';
import readItem from './helpers/read-item';
import updateItem from './helpers/update-item';
import deleteItem from './helpers/delete-item';
import {actionTypes} from 'redux-resource';

const RESOURCE_NAME = 'files';
const UPLOADS_TASKS = ['mediaTask', 'posterTask'];

/**
 * Run uploads task from values.
 *
 * Upload task should consist of:
 * <ul>
 *   <li> task.name - string which represents task's name
 *        and its field's name in file details values; </li>
 *   <li> task.upload - function which uploads file
 *        to firebase and return promise. </li>
 * </ul>
 *
 * @param {object} fileDetails - File details
 * @return promise pool with uploaded tasks */
function uploadTasks(fileDetails) {
	return at(fileDetails, UPLOADS_TASKS)
		.filter(task => task)
		.map(task => task.upload());
}

export const createFile = values => dispatch => {
	dispatch({
		type: actionTypes.CREATE_RESOURCES_PENDING,
		resourceName: RESOURCE_NAME,
		request: 'create'
	});

	const details = omit(values, UPLOADS_TASKS);
	const promises = uploadTasks(values);

	return Promise.all(promises)
		.then(() => dispatch(
			createItem(RESOURCE_NAME, details)
		)).catch(error => {
			const status = error.isCanceled ?
				actionTypes.CREATE_RESOURCES_NULL :
				actionTypes.CREATE_RESOURCES_FAILED;

			dispatch({
				type: status,
				resourceName: RESOURCE_NAME,
				request: 'create'
			});
		});
};

export function readAllFiles() {
	return readList(RESOURCE_NAME, 'all');
}

export function readFiles(parentId) {
	return readList(
		RESOURCE_NAME,
		`cat-${parentId}`,
		query => query.orderByChild('collection').equalTo(parentId)
	);
}

export function readFile(id) {
	return readItem(RESOURCE_NAME, id);
}

export const updateFile = values => dispatch => {
	dispatch({
		type: actionTypes.UPDATE_RESOURCES_PENDING,
		resourceName: RESOURCE_NAME,
		request: 'update'
	});

	const details = omit(values, UPLOADS_TASKS);
	const promises = uploadTasks(values);

	return Promise.all(promises)
		.then(() => dispatch(
			updateItem(RESOURCE_NAME, details)
		)).catch(error => {
			const status = error.isCanceled ?
				actionTypes.UPDATE_RESOURCES_NULL :
				actionTypes.UPDATE_RESOURCES_FAILED;

			dispatch({
				type: status,
				resourceName: RESOURCE_NAME,
				request: 'update'
			});

			throw error;
		});
};

export function deleteFile(id) {
	return deleteItem(RESOURCE_NAME, id);
}

export function dropStatus() {
	return dispatch => {
		dispatch({
			type: actionTypes.CREATE_RESOURCES_NULL,
			resourceName: RESOURCE_NAME,
			request: 'create'
		});

		dispatch({
			type: actionTypes.UPDATE_RESOURCES_NULL,
			resourceName: RESOURCE_NAME,
			request: 'update'
		});
	};
}



// WEBPACK FOOTER //
// ./src/client/redux/actions/files.js